<template>
  <div class="rightContent">
    <div class="msg-tip">注意：训练的体验时长只有30秒，无法达到训练效果。如需正常训练，请在档案页面选择患者进行现场训练。</div>
    <trainMenu ref="trainmenu" @trainmenuEvent="trainFun" :trainCategories='trainCategories'
    @category-path-updated = 'onTrainCategoryChoose' :isModal="isModal"></trainMenu>
    <component :noTrain="noTrain" ref="traincontent" :is="currentView" :trainCategories='trainCategories'
      :trainList = 'currentTrainCategory ? sortGame(currentTrainCategory.games) : []'>
    </component>
  </div>
</template>

<script>
  import Vue from 'vue'
  import store from '../store/index.js'
  import trainMenu from '../components/common/trainMenu.vue'
  import trainContent from '../components/service/train/trainContent.vue'
  import digTrainContent from '../components/service/train/digTrainContent.vue'
  import bz_utils from '../components/common/tree/utils/index.js'

  /**
  * 创建分类的树状结构
  */
  let trainCats = bz_utils.buildTrainCategoryTree();
  export default {
    data(){
      return {
        trainCategories: trainCats,
        currentTrainCategory: null,
        trains: null,
        count:0,
        isModal:false,
        noTrain:false,
      }
    },
    computed: {
      currentView: function(){
        return 'digTrainContent';
      },
    },
    components: {
      trainMenu,
      trainContent,
      digTrainContent
    },
    methods: {
      trainFun:function(evtValue1,evtValue2,evtValue3){
        this.$refs.traincontent.traincontentCall(evtValue1,evtValue2,evtValue3);
      },
      onTrainCategoryChoose(categoryPath){
        this.noTrain = false;
        if(categoryPath.length > 1 && categoryPath.slice(-1)[0].games.length == 0 && !this.noContent){
          this.noTrain = true;
        }
        var self = this;
        let cat = categoryPath.slice(-1)[0];
        this.currentTrainCategory = cat;
        if (this.trains === null){
          Vue.http({
            method: 'GET',
            url: '/api/Game/getAllGames',
          }).then(resp=>{
            console.log(Object.keys(resp.data.data));
             console.log(resp.data.data);
            let flat_games = bz_utils.canonicalizeGames(resp.data.data);
            self.trainCategories.resetGames(flat_games);
            self.trains = flat_games;
            self.count ++;
          })
        }
      },
      sortGame: function(games){
        var arr = [];
        var obj = {}; //去重
        if(this.count > 0){
          this.trains.forEach((item)=>{
            games.forEach((game)=>{
              if(game.id == item.id){
                arr.push(game);
              }
            })
          })
        }
        arr = arr.reduce((cur,next) => {
          obj[next.name] ? "" : obj[next.name] = true && cur.push(next);
          return cur;
        },[]);
        return arr;
      },
    }
  }
</script>
<style lang="stylus">
  @import "../assets/css/app.styl"
  @import "../assets/css/variable.styl"

  .rightContent
    position absolute
    left 231px
    top $top-height
    right 0
    height calc(100% - 101px)
  .msg-tip
    height 30px
    line-height 30px
    padding-left 20px
    color #e75710
    background-color rgba(10,129,229,0.05)
</style>



// WEBPACK FOOTER //
// train.vue?0549830f